module.exports = __webpack_public_path__ + "static/media/RoadMap.576786c1.png";